function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "weed",
  transform: "translate(-1.889 -2.049)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M20,19A32.465,32.465,0,0,1,24,4a32.465,32.465,0,0,1,4,15,32.465,32.465,0,0,1-4,15A32.465,32.465,0,0,1,20,19Z",
  transform: "translate(0.981)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M34.8,26.9a19.5,19.5,0,0,1,9.1-4.8,19.956,19.956,0,0,1-4.8,9.1A18.459,18.459,0,0,1,30,36,19.956,19.956,0,0,1,34.8,26.9Z",
  transform: "translate(1.962 1.288)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M37,40a12.947,12.947,0,0,1,7.6,3A12.947,12.947,0,0,1,37,46a12.947,12.947,0,0,1-7.6-3A12.947,12.947,0,0,1,37,40Z",
  transform: "translate(1.962 2)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M13.2,26.9a19.5,19.5,0,0,0-9.1-4.8,19.956,19.956,0,0,0,4.8,9.1A18.459,18.459,0,0,0,18,36,19.956,19.956,0,0,0,13.2,26.9Z",
  transform: "translate(0 1.288)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  d: "M11,40a12.947,12.947,0,0,0-7.6,3A12.947,12.947,0,0,0,11,46a12.947,12.947,0,0,0,7.6-3A12.947,12.947,0,0,0,11,40Z",
  transform: "translate(0 2)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgWeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46.185,
    height: 46.951,
    viewBox: "0 0 46.185 46.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeed);
export default __webpack_public_path__ + "static/media/weed.5256fa76.svg";
export { ForwardRef as ReactComponent };